<template>
  <Paper class="identificationPrintPaper">
    <div class="queryCondition">
      <div class="fristQueryCondition">
        <el-row>
          <el-col :span="22">
            <el-row>
              <el-col class="queryCondition-list">
                <el-input v-model="inquireData['identityCode']" @keyup.enter.native="searchChange" :placeholder="$translate('lang.E3202103080001', { defaultText: '标识编码' })"> </el-input>
              </el-col>
              <el-col class="queryCondition-list">
                <el-input v-model="inquireData['productName']" @keyup.enter.native="searchChange" :placeholder="$translate('lang.E3202103080002', { defaultText: '产品名称' })"> </el-input>
              </el-col>
              <el-col class="queryCondition-list">
                <span class="changSecltPosition">
                    <el-input
                      class="changSecltPosition-input"
                      v-model="inquireData['templateName']"
                      :placeholder="$translate('lang.E3202103080003', { defaultText: '产品模板' })"
                      @focus="templateSearch"
                    ></el-input>
                    <div class="changSeclt-icon">
                      <img
                        class="checkTemplate"
                        src="../../../assets/images/add-option.svg"
                        alt
                        @click="templateSearch"
                      />
                    </div>
                  </span>
              </el-col>
              <el-col class="queryCondition-list">
                <el-input v-model="inquireData['createUserCode']" @keyup.enter.native="searchChange" :placeholder="$translate('lang.E3202102250026', { defaultText: '创建人' })"> </el-input>
              </el-col>
              <div>
                <el-button type="primary" size="mini" :loading="loading" @click="searchChange" icon='el-icon-search'>
                  {{$translate('lang.E3202101260004', { defaultText: '查 询' })}}
                </el-button>
                <el-button @click="restSearchChange" size="mini" class="sn-search-reset-button">
                  {{$translate('lang.E3202101260009', { defaultText: '重 置' })}}
                </el-button>
              </div>
            </el-row>
            <el-row class="secondQueryCondition">
              <el-col class="queryCondition-list">
                <el-date-picker
                      class="queryCondition-list-search-date-picker"
                      v-model="inquireData['establishTime']"
                      type="datetimerange"
                      align="left"
                      :default-time="['00:00:00', '23:59:59']"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      unlink-panels
                      range-separator="-"
                      :start-placeholder="$translate('lang.E3202101270023', { defaultText: '开始日期' })"
                      :end-placeholder="$translate('lang.E3202101270024', { defaultText: '结束日期' })"
                      size="mini"
                      :picker-options="pickerOptions"
                    ></el-date-picker>
              </el-col>
              <el-col class="queryCondition-list">
                <el-select v-model="inquireData['tenantCode']" :placeholder="$translate('lang.E3202203010001', { defaultText: '企业前缀' })">
                  <el-option
                      v-for="item in tenantList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>
              </el-col>
              <el-col class="queryCondition-list">
                <el-select v-model="inquireData['status']"  clearable :placeholder="$translate('lang.E2202211230003', { defaultText: '注册状态' })" >
                  <el-option :label="$translate('lang.E2202211230001', { defaultText: '成功' })" value="Y"></el-option>
                  <el-option :label="$translate('lang.E2202211230002', { defaultText: '失败' })" value="N"></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="showinquireTable">
      <inquire-Table
        ref="inquireTable"
        @rowDBclick="rowDBclick"
        :pageTotal="pageTotal"
        :config="config"
        :tableData="totalData"
        @onSelectionChange="inquireTableSelection"
        @switch-change="switchChange"
        @pageChange="pageChange"
        @sizeChange="sizeChange"
      >
      <div slot='page-module-btn'>
        <el-button type="primary" size="mini" @click="identificationPrintSure" icon="el-icon-printer">
        {{$translate('lang.E3202103080004', { defaultText: '打印' })}}
      </el-button>
      </div>
      </inquire-Table>
    </div>
    <!-- 点击选择模板 -->
    <el-dialog
      class="templateClass"
      :title="$translate('lang.E3202103080005', { defaultText: '模板选择' })"
      :close-on-click-modal="false"
      :visible.sync="productTemplate"
      width="50%"
    >
      <templateComponents
        ref="templateRef"
        :config="templateJson"
        :pageTotal="templateJsonTotal"
        :tableData="templateJsonTableData"
        @onSearchChange="templateJsonSearch"
        @onSelectionChange="templateJsonSelec"
        @pageChange="templateJsonPageChange"
        @sizeChange="templateJsonSizeChange"
      ></templateComponents>
      <span slot="footer" class="dialog-footer">
        <el-button @click="productTemplate = false">
          {{$translate('lang.E3202101270002', { defaultText: '取 消' })}}
        </el-button>
        <el-button type="primary" @click="getTemplateSure">
          {{$translate('lang.E3202101270001', { defaultText: '确 定' })}}
        </el-button>
      </span>
    </el-dialog>
  </Paper>
</template>
<script>
import Paper from '@/components/core/paper/Paper';
import inquireTable from '../../../components/IdentityComponent/Main';
import config from './config.js';
import configHttp from '@/config/user.env';
import templateJson from './template.js';
import templateComponents from '../../../components/IdentityComponent/Main.vue';
import {
    getIdentifyingList,
    getTemplate,
    changeState
} from '../../../api/IdentityInquire';
import { getTenant } from '../../../api/systemManagementApi';
import dayjs from 'dayjs';

// 导出时间间隔,不超过14天
const TIME_INTERVAL_EXPORT = 24 * 60 * 60 * 1000 * 14;

export default {
    name: 'IdentityInquire',
    components: { Paper, inquireTable, templateComponents },
    data() {
        return {
            config: config,
            configHttp: configHttp,
            templateJson: templateJson,
            pickerOptions: {},
            inquireData: {
                identityCode: '',
                productName: '',
                templateName: '',
                createUserCode: '',
                tenantCode: ''
            },
            totalData: [],
            pageTotal: 1,
            loading: false,
            productTemplate: false,
            templateJsonTotal: 0,
            templateJsonTableData: [],
            page: {
                pageSize: 10,
                pageNo: 1
            },
            templateSearchData: {},
            templateSelectData: [],
            inquireTableSelectData: [],
            tenantList: []
        };
    },
    methods: {
        switchChange(data) {
            changeState([data]).then(res => {
                if (res.code === '0') {
                    const params = {
                        ...this.inquireData,
                        ...this.page
                    };
                    this.getIdentifyingList(params);
                }
            });
        },
        searchChange() {
            this.$refs.inquireTable.$refs.page.pageState = false;
            this.page.pageNo = 1;
            this.config.page.pageSize = this.page.pageSize;
            const params = {
                ...this.page,
                ...this.inquireData
            };
            this.loading = true;
            this.getIdentifyingList(params);
            this.$nextTick(() => {
                this.$refs.inquireTable.$refs.page.pageState = true;
            });
        },
        getIdentifyingList(params) {
            if (!this.inquireData.establishTime) {
                this.$message.warning(this.$translate('lang.EXC202101270005', { defaultText: '请选择查询日期' }));
                this.loading = false;
                return;
            }
            // 如果有time参数 判断时间范围是否合法
            if (this.inquireData.establishTime) {
                params['startTime'] = params['establishTime'][0];
                params['endTime'] = params['establishTime'][1];
                if (
                    new Date(params.endTime).getTime() -
                        new Date(params.startTime).getTime() >
                    TIME_INTERVAL_EXPORT
                ) {
                    this.$message.warning(
                        '时间范围不得超过14天，请修改查询时间范围！',
                        this.loading = false
                    );
                    return true;
                }
            }
            if (!this.inquireData.tenantCode) {
                this.$message.warning(this.$translate('lang.E2202203020001', { defaultText: '请选择企业前缀' }));
                this.loading = false;
                return;
            }
            params['startTime'] = params['establishTime'][0];
            params['endTime'] = params['establishTime'][1];
            if (this.templateSelectData.length > 0) {
                params['productTemplateCode'] = this.templateSelectData[0].templateCode;
            }
            delete params.establishTime;
            delete params.templateName;
            getIdentifyingList(params)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.totalData = res.data.list;
                        this.pageTotal = res.data.totalCount;
                    }
                }).catch(res => {
                    if (res && !res.code) {
                        this.$message.warning('当前查询数据量过大，响应超时请尝试缩短时间范围或者添加其他查询条件');
                    }
                }).finally(() => {
                    this.loading = false;
                });
        },
        restSearchChange() {
            this.inquireData['identityCode'] = '';
            this.inquireData['productName'] = '';
            this.inquireData['templateName'] = '';
            this.templateSelectData = [];
            this.inquireData['createUserCode'] = '';
            this.inquireData['tenantCode'] = '';
            this.getTime();
        },
        pageChange(pageNo) {
            this.page['pageNo'] = pageNo;
            const params = {
                ...this.inquireData,
                ...this.page
            };
            this.getIdentifyingList(params);
        },
        sizeChange(pageSize) {
            this.page['pageSize'] = pageSize;
            const params = {
                ...this.inquireData,
                ...this.page
            };
            this.getIdentifyingList(params);
        },
        inquireTableSelection(data) {
            this.inquireTableSelectData = data;
        },
        // 更改打印次数
        changePrint() {
            changeState(this.inquireTableSelectData).then(res => {
                if (res.code === '0') {
                    const params = {
                        ...this.inquireData,
                        ...this.page
                    };
                    this.getIdentifyingList(params);
                }
            });
        },
        // 标识打印
        async identificationPrintSure() {
            if (this.inquireTableSelectData.length === 0) {
                this.$message.warning(this.$translate('lang.EXC202103080001', { defaultText: '至少选择一条打印信息' }));
                return;
            }
            await this.changePrint();
            const stringArray = [];
            this.inquireTableSelectData.map(item => {
                const string = item.identityCode;
                stringArray.push(string);
            });
            const endString = stringArray.join(',');
            const lessString = this.inquireTableSelectData[0].prefixCode;
            window.open(
                this.configHttp.apiUrl + '/api-printer/preview?_report=ReportIdentity_copy&_ignore=true&identityCodes=' +
          endString +
          '&prefixCode=' +
          lessString,
                '_blank'
            );
        },
        // 详情ver
        rowDBclick(row) {
            this.$router.push({
                path: '/IdentityInquireDetail',
                query: { message: row }
            });
        },
        // 模板选择
        templateSearch() {
            this.inquireData['templateName'] = '';
            this.productTemplate = true;
            const params = {
                ...this.page
            };
            this.getTemplate(params);
            if (this.$refs.templateRef) {
                this.$refs.templateRef.$refs.SearchLsit.clearsearchData();
            }
        },
        getTemplateSure() {
            this.inquireData['templateName'] = this.templateSelectData[0].templateName;
            this.productTemplate = false;
        },
        getTemplate(params) {
            getTemplate(params).then(res => {
                if (res.code === '0') {
                    this.templateJsonTableData = res.data.list;
                    this.templateJsonTotal = res.data.totalCount;
                }
            });
        },
        templateJsonSearch(data) {
            this.templateSearchData = data;
            const params = {
                ...this.page,
                ...data
            };
            this.getTemplate(params);
        },
        templateJsonSelec(data) {
            this.templateSelectData = data;
        },
        templateJsonPageChange(pageNo) {
            const params = {
                ...this.page,
                ...this.templateSearchData
            };
            params['pageNo'] = pageNo;
            this.getTemplate(params);
        },
        templateJsonSizeChange(pageSize) {
            const params = {
                ...this.page,
                ...this.templateSearchData
            };
            params['pageSize'] = pageSize;
            this.getTemplate(params);
        },
        // 默认时间
        getTime() {
            const sameDay = dayjs().format('YYYY-MM-DD');
            this.$set(this.inquireData, 'establishTime', [
                sameDay + ' 00:00:00',
                sameDay + ' 23:59:59'
            ]);
        },
        getCompanyPrefix() {
            const params = {
                pageNo: 1,
                pageSize: 100
            };
            getTenant(params).then(res => {
                if (res && +res.code === 0) {
                    const data = res.data || {};
                    const tenantArray = data.list;
                    tenantArray.forEach(item => {
                        this.tenantList.push({
                            value: item.tenantCode,
                            label: item.tenantName
                        });
                    });
                }
            });
        }
    },
    async mounted() {
        this.getTime();
        await this.getCompanyPrefix();
    }
};
</script>
<style lang="less">
.identificationPrintPaper {
  // 选择产品模板-图标
  .checkTemplate {
    cursor: pointer;
  }
  // 查询条件
  .queryCondition {
    .secondQueryCondition {
      margin: 12px 0 20px;
    }
  }
  .queryCondition-list {
    width: 190px;
    margin-right: 10px;
    .changSecltPosition {
      position: relative;
      width: 100%;
      .changSecltPosition-input{
        width: 100%;
      }
    }
    .el-select{
      width: 100%;
    }
    .queryCondition-list-search-date-picker{
      width: 100%;
      .el-range__icon {
          display: none;
      }
    }
    .changSeclt-icon {
      position: absolute;
      height: 100%;
      width: 20px;
      top: 2px;
      right: 0;
    }
  }
  .showinquireTable {
    .nPanel .el-table {
      height: calc(100vh - 220px) !important;
    }
    .nPanel .row-bg {
      margin-top: 20px;
    }
  }
  .templateClass {
    .nPanel .el-table {
      height: calc(100vh - 500px) !important;
    }
  }
  #identificationPrint {
    .el-form--inline .el-form-item {
      margin-right: 80px;
    }
    .el-dialog__body {
      width: 30vw;
    }
    .el-dialog__footer {
      border-top: 1px solid #e6e6e6;
    }
    .secondCode {
      display: inline-block;
      width: 200px;
      height: 200px;
    }
  }
}
</style>